import { GridRecord } from '../../components/Grid/GridDataTypes';
import {
  CreateUpdateAuthorizedDto,
  CreateUpdateAuthorizedDtoFromJSON,
  DefaultApi,
  GetAuthorizedDto,
  GetLastEditorDto,
} from '../autogenerated/pokApiClient';
import { validateAgainst } from '../validation/validateAgainst';
import { AuthorizedSchema } from '../validation/schemas';
import { authorizedForGrid } from '../../../pok/components/Authorized/AuthorizedSearch';

export interface AuthorizedContextInterface {
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string, filterColumns?: string) => Promise<number>;
  getById: (id: string) => Promise<GetAuthorizedDto>;
  update: (id: string, dto: CreateUpdateAuthorizedDto) => Promise<void>;
  create: (dto: CreateUpdateAuthorizedDto) => Promise<GetAuthorizedDto>;
  getLastEditor: (id: string) => Promise<GetLastEditorDto>;
}

export const AuthorizedContext = (api: DefaultApi) => {
  return {
    getAllByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) => {
      const data = await api.authorizedControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        filterColumns,
      );
      return data.map(authorizedForGrid);
    },
    getAllCount: (filterText?: string, filterColumns?: string) =>
      api.authorizedControllerGetAllCount(filterText || '', filterColumns),
    getById: (id: string) => api.authorizedControllerGet(id),

    update: (id: string, dto: CreateUpdateAuthorizedDto) =>
      api.authorizedControllerUpdate(id, dto),
    create: (dto: CreateUpdateAuthorizedDto) =>
      api.authorizedControllerCreate(dto),
    getLastEditor: (id: string) => api.authorizedControllerGetLastEditor(id),
  };
};

export const newAuthorized = () => {
  return CreateUpdateAuthorizedDtoFromJSON({});
};

export const validate = (authorized: CreateUpdateAuthorizedDto) =>
  validateAgainst(AuthorizedSchema, authorized);

export const convert = (authorized?: GetAuthorizedDto) => {
  if (!authorized) {
    return newAuthorized();
  }
  const converted = CreateUpdateAuthorizedDtoFromJSON(authorized);
  converted.employeeId = authorized?.employee?.id;
  converted.companyId = authorized?.company?.id;
  converted.teamId = authorized?.team?.id;
  return converted;
};
